'use client'

import { captureException } from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    captureException(error, {
      level: 'fatal',
      tags: {
        errorBoundary: 'app/global-error.tsx',
      },
      extra: {
        digest: error.digest,
        message: error.message,
        url: window.location.href,
        pathname: window.location.pathname,
      },
    })
  }, [error])

  return (
    <html lang="pt-BR">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
